<template>
  <div class="praise">
    <nav-bar title="我的点赞" />
    <van-pull-refresh
      v-model="refreshing"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <van-list
        v-model:loading="loading"
        :finished="finished"
        :finished-text="list.length > 1 ? '已加载全部' : ''"
        @load="onLoad"
      >
        <ul class="praise-list">
          <li v-for="item in list" :key="item.ActionId">
            <a
              v-if="item.Article"
              href="javascript:;"
              @click="$go('CaseDetail', { params: { id: item.ArticleId } })"
            >
              <!-- <div class="hd">我赞了这篇帖子</div> -->
              <div v-if="item.Article" class="bd flex">
                <div class="face">
                  <van-image
                    fit="cover"
                    height="80"
                    :src="$getAvatar(item.UserInfo && item.UserInfo.Avatar)"
                    width="80"
                  />
                </div>
                <div class="content flex-1">
                  <h4>{{ item.UserInfo && item.UserInfo.NickName }}</h4>
                  <p>{{ item.Article && item.Article.Title }}</p>
                </div>
              </div>
              <div v-else class="del">该帖子已被删除</div>
            </a>
          </li>
        </ul>
      </van-list>
      <van-empty v-if="!list.length" description="暂无数据" image="default" />
    </van-pull-refresh>
  </div>
</template>
<script>
  import { reactive, ref, toRefs, watch } from 'vue'
  import NavBar from '@/components/NavBar'
  import store from '@/store'
  import api from '@/api'
  import { ImagePreview, Toast } from 'vant'
  import { useRouter } from 'vue-router'
  export default {
    components: { NavBar },
    props: {
      url: {
        type: String,
        default: 'case/PostSelectByTenant',
      },
      params: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    setup(props) {
      //是否打开页面立即加载数据 （当为搜索页时不立即加载）
      const list = ref([])
      const loading = ref(false)
      const finished = ref(false)
      const refreshing = ref(false)
      const { url, params, isSearch } = toRefs(props)
      const router = useRouter()
      const form = {
        ActionType: 3,
        PageIndex: 1,
        PageSize: 6,
        //TenantId: store.getters['user/getTenantId'],
      }

      watch(
        params,
        (newVal, oldVal) => {
          list.value = []
          form.PageIndex = 1
          onLoad()
        },
        {
          deep: true,
        }
      )

      const goto = (name, option) => {
        router.push(Object.assign(option, { name }))
      }

      const onLoad = async () => {
        await sleep(300)
        //setTimeout(() => {
        if (refreshing.value) {
          list.value = []
          form.PageIndex = 1
          //refreshing.value = false
          finished.value = false
        }
        form.TenantId = (await store.getters['user/getTenant']).TenantId
        Object.assign(form, params.value)
        store
          .dispatch('case/GetArticlesByAction', form)
          .then(async (data) => {
            const resList = data.Data.CurrentPage
            if (resList.length) {
              const userIdsList = []
              const ArticleIdsList = []
              resList.forEach(async (item) => {
                if (item.ArticleId) ArticleIdsList.push(item.ArticleId)
              })
              await setArticleInfo(resList, ArticleIdsList)
              resList.forEach(async (item) => {
                if (item.Article && item.Article.CreatedBy)
                  userIdsList.push(item.Article.CreatedBy)
              })
              await setUserInfo(resList, userIdsList)
              resList.forEach(async (item) => {
                list.value.push(item)
              })
              form.PageIndex++
            } else {
              finished.value = true
            }
            if (list.value.length >= data.Data.Total) {
              finished.value = true
            }
            setTimeout(() => {
              refreshing.value = false
              loading.value = false
            }, 800)
          })
          .catch((e) => {
            setTimeout(() => {
              //finished.value = true
              loading.value = false
            }, 500)
          })
      }

      const setArticleInfo = (resList, ArticleIdsList) => {
        return new Promise((resolve, reject) => {
          return store
            .dispatch('case/PostSelectByIdList', {
              idList: ArticleIdsList,
            })
            .then((data) => {
              const d = data.Data.CurrentPage
              resList.forEach((item) => {
                d.forEach((item2) => {
                  if (item.ArticleId === item2.Id) {
                    item.Article = item2
                  }
                })
              })
              resolve()
            })
            .catch((e) => {
              resolve()
            })
        })
      }

      const setUserInfo = async (resList, list) => {
        const TenantId = (await store.getters['user/getTenant']).TenantId
        return new Promise((resolve, reject) => {
          const arr = Array.from(new Set(list))
          store
            .dispatch('user/GetUserList', {
              TenantId,
              userIDs: arr,
            })
            .then((data) => {
              const d = data.Data
              resList.forEach((item) => {
                d.forEach((item2) => {
                  if (
                    (item.Article && item.Article.CreatedBy) === item2.UserId
                  ) {
                    item.UserInfo = item2
                  }
                })
              })
              resolve()
            })
            .catch((e) => {
              resolve()
            })
        })
      }

      const sleep = (ms) => {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve()
          }, ms)
        })
      }

      const getContent = (data, num) => {
        let res = data
        if (num) {
          res = res.substring(0, num) + '...'
        }
        res = res.replace(/\n/g, '<br/>')
        return res
      }

      const onRefresh = () => {
        // 清空列表数据
        finished.value = false

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        loading.value = true
        onLoad()
      }

      const showImg = (list, index) => {
        const arr = []
        list.forEach((item) => {
          arr.push(api.FileHost + item)
        })
        ImagePreview({
          images: arr,
          startPosition: index,
          closeable: true,
        })
      }

      const zanHandle = (item) => {
        const params = {
          ArticleId: item.Id,
          OperationType: 3,
        }
        let url = 'case/ArticleOperationIncrease'
        if (item.Article && item.Article.IsPraise) {
          url = 'case/ArticleOperationCancel'
        }
        store
          .dispatch(url, params)
          .then((data) => {
            if (item.Article.IsPraise) {
              item.Article.PraiseNum--
              item.Article.IsPraise = false
              Toast.success('取消点赞成功')
            } else {
              item.Article.IsPraise = true
              item.Article.PraiseNum++
              Toast.success('点赞成功')
            }
          })
          .catch((e) => {
            Toast.fail('点赞失败')
          })
      }

      return {
        list,
        onLoad,
        loading,
        finished,
        onRefresh,
        refreshing,
        api,
        showImg,
        getContent,
        goto,
        zanHandle,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .praise {
    padding: 54px 0 0;
  }
  .praise-list {
    li {
      background: #fff;
      margin-bottom: 10px;
      a {
        color: #444;
        display: block;
        padding: 10px 16px 12px;
      }
      .hd {
        //border-bottom: 1px solid #eee;
        padding-bottom: 8px;
      }
      .del {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 2px;
        font-size: 14px;
        color: #999;
      }
      .bd {
        background: #f5f5f5;
        height: 80px;
        overflow: hidden;
        h4 {
          margin: 0;
          font-size: 16px;
          font-weight: normal;
        }
        .content {
          margin-left: 5px;
          padding: 5px;
          p {
            color: #999;
            font-size: 14px;
            height: 44px;
            overflow: hidden;
            margin-top: 5px;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }
</style>
